import { FlowNodeTypes } from '../types'

// Existing agents still load these, but the runtime sends every run down the Error path.
const RETIRED_NODE_REASONS: Partial<Record<FlowNodeTypes, string>> = {
  [FlowNodeTypes.ai_skills]:
    'Skills node retired. It always takes its Error path, so replace it to keep this agent working.',
}

export const retiredNodeReason = (nodeType?: string): string | undefined =>
  RETIRED_NODE_REASONS[nodeType as FlowNodeTypes]
